import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import { persistedReducer } from "./persistConfig"; // Adjust import path as needed

const store = configureStore({
  reducer: persistedReducer, // Use persistedReducer here
  // Add other store configurations if needed
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
        ],
        ignoredPaths: ["persist.purged"],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
